export const BRAND_NAME = "Visive Advertising";
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/brand-placeholder.svg`;
